const STEPS = [
  {
    title: "Τα φύλλα",
    body: "Κάθε γευστική παίρνει φύλλο. Το όνομα είναι ο χώρος και η ημερομηνία, γραμμένη ανάποδα.",
    points: [
      "Νέο φύλλο ανοίγει μόλις αρχίσουν να ορίζονται τα ραντεβού.",
      "Αριστερά μένει το νεότερο φύλλο και δεξιά το παλαιότερο.",
      "Με το κλείσιμο, τα στοιχεία αντιγράφονται στο Master με το χέρι.",
      "Τα φύλλα δεν συνδέονται μόνα τους με το Master.",
      "Στο Master οι γραμμές μπαίνουν αλφαβητικά, με το επώνυμο.",
    ],
  },
  {
    title: "Δύο ρόλοι",
    body: "Η πρόσβαση μένει σε δύο ρόλους, όπως στο βιβλίο.",
    points: [
      "Χειριστής: γράφει και διορθώνει τις ενότητες.",
      "Χρήστης: βλέπει τις πληροφορίες και δεν τις αλλάζει.",
    ],
  },
  {
    title: "Γαλάζια ενότητα",
    body: "Εδώ μένουν το ραντεβού, η επιθυμία του πελάτη και η κρίση.",
    points: [
      "Επίσκεψη: αριθμός, ονοματεπώνυμο, ώρα, ημερομηνία, άτομα στη δοκιμή, τραπέζι, πωλητής.",
      "Επιθυμία: ημερομηνία, τύπος, εκτιμώμενοι καλεσμένοι, χώρος, τηλέφωνο, email.",
      "Αξιολόγηση Top, High, Mid ή Low. Η τελική κωδικοποίηση μένει να επιβεβαιωθεί.",
      "Αν έκλεισε, επόμενη επικοινωνία, σημειώσεις και αρχεία.",
    ],
  },
  {
    title: "Κόκκινη ενότητα",
    body: "Εδώ γράφονται η δέσμευση και τα οριστικά. Μπορούν να διαφέρουν από την αρχική επιθυμία, και τα δύο μένουν.",
    points: [
      "Προφορική δέσμευση, συμφωνητικό και προκαταβολή. Η προκαταβολή είναι κρίσιμο πεδίο.",
      "Οριστικά: ημερομηνία, τύπος, χώρος, κωδικός φακέλου και άτομα.",
      "Οι κενές χρωματιστές στήλες δεν είναι στοιχεία. Χωρίζουν τις ενότητες.",
      "Οταν αυτή είναι η πιο προχωρημένη ενότητα, η λίστα τη δείχνει ως Εκκρεμότητες προκαταβολής.",
    ],
  },
  {
    title: "Κίτρινη ενότητα",
    body: "Εδώ γράφεται η λειτουργία της ημέρας, μαζί με σχόλια και αρχεία.",
    points: [
      "Χώρος, ζώνη ώρας (μεσημέρι ή απόγευμα-βράδυ), μενού, στήσιμο, ειδικές απαιτήσεις.",
      "DJ της επιχείρησης, πυροτεχνήματα, εκκλησία της επιχείρησης, αλλεργίες, λίστα καλεσμένων.",
      "Τύπος: γάμος, βάπτιση, γάμος και βάπτιση, ή εταιρική.",
    ],
  },
  {
    title: "Η φάση στην οθόνη",
    body: "Η φάση είναι η πιο προχωρημένη ενότητα που έχει έστω ένα συμπληρωμένο κελί.",
    points: [
      "Κενό κελί δεν αλλάζει φάση.",
      "Το να γράψεις κλεισ στις σημειώσεις δεν αλλάζει από μόνο του το στάδιο πωλήσεων.",
      "Το στάδιο μένει ξεχωριστό και αλλάζει μόνο όταν το ορίσεις.",
    ],
  },
] as const;

export function ProcessPage() {
  return (
    <>
      <header className="page-head">
        <div>
          <h1>Η ροή</h1>
          <p className="lede">Η φάση στην οθόνη είναι η πιο προχωρημένη ενότητα με γραμμένο κελί. Το στάδιο πωλήσεων είναι ξεχωριστό.</p>
        </div>
      </header>
      <ol className="brief">
        {STEPS.map((step, index) => (
          <li className="panel" key={step.title}>
            <p className="step-no">Βήμα {index + 1}</p>
            <h2>{step.title}</h2>
            <p>{step.body}</p>
            <ul>
              {step.points.map((point) => <li key={point}>{point}</li>)}
            </ul>
          </li>
        ))}
      </ol>
    </>
  );
}
